<script>
import FormFieldCheckbox from "./FormFieldCheckbox.vue";
export default {
	...FormFieldCheckbox,
	name: "FormFieldRadio",
};
</script>
